// Invisible format characters (word joiner, zero-width space, BOM, ...) ride
// along when an email is copied from chat apps or web pages.
const INVISIBLE_CHARACTERS = /\p{Cf}/gu;

export const normalizeEmail = (email: string): string =>
  email.replace(INVISIBLE_CHARACTERS, "").trim();
